export function ValuesSection() {
  const values = [
    {
      icon: '/icons/transparency.svg',
      title: 'Şeffaflık',
      description:
        'Her kararı ve süreçi açıkça paylaşırız.\nMüşterilerimiz ve ekibimizle güven temelli\nilişkiler kurarız.',
    },
    {
      icon: '/icons/speed.svg',
      title: 'Hız',
      description:
        'Hızlı düşünür, hızlı uygularız. İteratif geliştirme\nile değeri en kısa sürede müşteriye ulaştırırız.',
    },
    {
      icon: '/icons/curiosity.svg',
      title: 'Merak',
      description:
        'Durağanlığı reddederiz. Sürekli soru sorar,\növrenir ve sınırları zorlarız.',
    },
    {
      icon: '/icons/team.svg',
      title: 'Takım',
      description:
        'En iyi fikirlerin çeşitlilikten doğduğuna inanırız.\nBirlikte daha güçlüyüz.',
    },
    {
      icon: '/icons/quality.svg',
      title: 'Kalite',
      description:
        'Detaylara takıntılı derecede önem veririz.\n"Yeterince iyi" bize yetmez.',
    },
    {
      icon: '/icons/responsibility.svg',
      title: 'Sorumluluk',
      description:
        'Veriye ve müşteri güvenine saygı duyarız. Etik\nstandartlarımızdan asla taviz vermeyiz.',
    },
  ];

  return (
    <>
      <style
        dangerouslySetInnerHTML={{
          __html: `
          @media (max-width: 768px) {
            .mobile-values-section {
              padding-top: 40px !important;
              padding-bottom: 40px !important;
            }
            .mobile-values-container {
              padding-left: 20px !important;
              padding-right: 20px !important;
            }
            .mobile-values-cards {
              grid-template-columns: 1fr !important;
              gap: 16px !important;
            }
            .mobile-values-card {
              padding: 20px !important;
              border-right: none !important;
            }
            .mobile-values-card:nth-child(3n) {
              border-right: none !important;
            }
            .mobile-values-title {
              font-size: 16px !important;
              line-height: 24px !important;
            }
            .mobile-values-description {
              font-size: 12px !important;
              line-height: 18px !important;
            }
          }
        `,
        }}
      />
      <div className="w-full py-[20px] bg-slate-950 flex flex-col justify-center items-center mobile-values-section">
        <div className="w-full max-w-[1200px] px-[60px] py-10 flex flex-col justify-start items-start gap-12 mobile-values-container">
          <div className="w-full flex justify-start items-center gap-3">
            <div
              className="size-2.5 rounded-[3px]"
              style={{ background: '#76BCE8' }}
            />
            <div className="inline-flex flex-col justify-start items-start">
              <div
                className="justify-center text-xs font-semibold font-['Inter'] uppercase tracking-widest"
                style={{ color: 'rgba(255, 255, 255, 0.5)' }}
              >
                Değerlerimiz
              </div>
            </div>
          </div>

          <div
            className="w-full bg-white bg-opacity-[0.06] rounded-[20px] grid grid-cols-3 gap-0 overflow-hidden mobile-values-cards"
            style={{ boxShadow: '0px 4px 40px 0px rgba(0, 150, 196, 0.25)' }}
          >
            {values.map((value, index) => (
              <div
                key={index}
                className="w-full px-9 py-12 bg-neutral-900 flex flex-col justify-start items-start gap-3 mobile-values-card hover:bg-[#1A1A1A] transition-all duration-300 cursor-pointer"
                style={{
                  borderRight:
                    (index + 1) % 3 === 0
                      ? 'none'
                      : '0.3px solid rgba(0, 150, 196, 0.25)',
                }}
              >
                <div className="size-12 bg-white bg-opacity-[0.03] rounded-xl border border-white border-opacity-[0.06] flex justify-center items-center">
                  <img src={value.icon} alt={value.title} className="size-5" />
                </div>
                <div className="w-full pt-4 flex flex-col justify-start items-start">
                  <div
                    className="w-full justify-center text-lg font-bold font-['Inter'] mobile-values-title"
                    style={{ color: '#FAFAFA' }}
                  >
                    {value.title}
                  </div>
                </div>
                <div className="w-full flex flex-col justify-start items-start">
                  <div
                    className="w-full justify-center text-xs font-normal font-['Inter'] leading-6 mobile-values-description"
                    style={{ color: 'rgba(255, 255, 255, 0.25)' }}
                  >
                    {value.description.split('\n').map((line, lineIndex) => (
                      <span key={lineIndex}>
                        {line}
                        {lineIndex <
                          value.description.split('\n').length - 1 && <br />}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
